import { defineMessages } from "react-intl";

export const welcomePageMessages = defineMessages({
  salesCardTitle: {
    defaultMessage: "Sales",
    id: "c8nvms",
  },
  outOfStockCardTitle: {
    defaultMessage: "Out of stock",
    id: "WHgdsk",
  },
});
